import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import Immutable from 'immutable';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { Paragraph } from '@uncinc/react-drupal-core';

import InformationOverlay from '../../../components/InformationOverlay';
import {
  Button,
  SwirlIllustrations,
  Logo,
  Share,
} from '../../../components';

import './style.scss';

const NodeResult = ({ entity, className }) => {
  const { t } = useTranslation();
  const classes = c(className, 'NodeResult');
  const paragraphs = entity.getIn(['field_paragraphs'], Immutable.Map());
  const linkUri = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title']);

  const copyToClipboard = () => {
    window.navigator.clipboard.writeText(window.location.href);
  };

  return (
    <article typeof="schema:WebPage" className={classes}>
      <Logo />

      <Container>
        <div className="row">
          <div className="col-12">
            <div className="NodeResult__content" id="main">
              {paragraphs.size && (
                <div className="NodeResult__paragraphs">
                  {paragraphs.map((item) => {
                    const paragraph = item.get('entity');
                    const paragraphId = item.get('target_id');
                    return (
                      <Paragraph key={paragraphId} entity={paragraph} id={paragraphId} />
                    );
                  })}
                </div>
              )}
              <div className="NodeResult__buttons">
                {linkUri && linkTitle && (
                  <Button className="NodeResult__link" type="primary" href={linkUri}>
                    {linkTitle}
                    <i className="icon icon-arrow-right" />
                  </Button>
                )}

                <InformationOverlay
                  overlayKey="Overlay_NodeResult"
                  buttonTitle={t('share')}
                  buttonIcon="share"
                  buttonClassName="Button--transparent"
                >
                  <h2 className="asH1">{t('share')}</h2>
                  <p>{t('share_text')}</p>
                  <Button
                    primary={false}
                    className="NodeResult__copy-link icon-before icon-link"
                    onClick={copyToClipboard}>
                    {t('copy_link.link_text')}
                  </Button>
                  <Share
                    title={null}
                    items={[
                      'whatsapp',
                      'mail',
                    ]}
                  />
                </InformationOverlay>
              </div>
            </div>
          </div>
        </div>
      </Container>

      <SwirlIllustrations
        variant={6}
      />
    </article>
  );
};

export default NodeResult;
